<div class="table--grid">
    <div class="table--grid__header">
        {{ 'Assesment Progress' | translate  }}
    </div>
    <div class="table--grid__body">
        <div class="row table--grid__body--header">
            <div class="col-xs-10">
                <div class="row">
                    <div *ngFor="let column of patientProgressTableColumns" class="{{ column[2] }}">
                        {{ column[1] | translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="table--grid__body table--grid__body--content">
            <ng-container *ngFor="let questionnaire of items; let last = last;">
                <div class="row hidden"></div>
                <div class="row">
                    <div class="col-xs-10" [ngClass]="{'active-questionnaire': last}" (click)="doAction(questionnaire)">
                        <div class="row d-flex align-items-center">
                            <div *ngFor="let column of patientProgressTableColumns" class="{{ column[2] }}">
                                <ng-container *ngIf="column[0] === 'sequence_text'">
                                    <span>
                                        {{ questionnaire['sequence_text_' + translate.currentLang] | translate}} {{ 'Assessment' | translate }}
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="column[0] === 'updated_at_diff'">
                                    <span>
                                        {{ questionnaire[column[0]] | dateDiffTranslate}}
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="column[0] === 'step_text'">
                                    <span>
                                        {{ questionnaire.step_text | translate }}
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="column[0] === 'latest_action'">
                                    <div class="progress-wrapper progress-{{questionnaire.progess_status_code}}">
                                        <span class="progress-label">
                                            {{questionnaire.progess_status_code * 12.5}}<span class="small">%</span>
                                        </span>
                                        <div class="shadow"></div>
                                        <div class="pie">
                                        <div class="left-side half-circle"></div>
                                        <div class="right-side half-circle"></div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-2" *ngIf="questionnaire.di_questionnaire && !questionnaire.di_questionnaire.archived">
                        <div class="pull-right">
                            <span *ngIf="!questionnaire.archived && questionnaire.status_text !== 'Completed'"
                                class="action__icon"
                                (click)="beginInterview(questionnaire);">
                                <i class="action__icon--fa sr-open" tooltip="{{ (questionnaire['status_text'] == 'Not started' ? 'Start interview' : 'Continue interview') | translate }}" container="body" placement="bottom"></i>
                            </span>
                            <span *ngIf="(questionnaire['status_text'] == 'Completed') || ((questionnaire.di_questionnaire['status_text'] == 'Completed' || questionnaire.di_questionnaire['status_text'] == 'Paused' || (questionnaire.step >= 4 && questionnaire.di_questionnaire['archived'] == 0)))"
                                class="action__icon"
                                (click)="confirmToArchive(questionnaire.di_questionnaire);">
                                <i class="action__icon--fa archive" tooltip="{{'Archive' | translate}}" container="body" placement="bottom"></i>
                            </span>
                            <span *ngIf="questionnaire.step === 0"
                                class="action__icon"
                                (click)="confirmToDelete(questionnaire.di_questionnaire);">
                                <i class="action__icon--fa delete" tooltip="{{'Delete' | translate}}" container="body" placement="bottom"></i>
                            </span>
                            <span *ngIf= "questionnaire.due_date && questionnaire.status_text !== 'Completed' && !questionnaire.archived"
                                class="action__icon"
                                (click)="openFormModal({ action: 'reminder', title: 'Send Reminder', id: questionnaire.id, url: 'patient/' + id, email: email});">
                                <i class="action__icon--fa sr-send-reminder" tooltip="{{ 'Send Reminder' | translate }}" container="body" placement="bottom"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<!--    SEND REMINDER MODAL -->
<div bsModal #modal="bs-modal" class="modal fade"
     [ngClass]="params['action'] === 'archive' || params['action'] === 'delete' ? 'modal-confirmation': params['action'] === 'reminder' ? 'patient-sendreminder-modal' : ''"
     tabindex="-1" role="dialog" aria-hidden="true">
    <!-- archive || delete -->
    <div *ngIf="params['action'] === 'archive' || params['action'] === 'delete'"
         class="modal-dialog modal-confirmation-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body text-xs-center">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="modal-icon">
                            <i *ngIf="params['action'] === 'archive'" class="fas fa-archive" aria-hidden="true"></i>
                            <i *ngIf="params['action'] === 'delete'" class="far fa-trash-alt" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
                <confirm-modal-body [responseMessage]="responseMessage" [params]="params"></confirm-modal-body>
                <div class="row">
                    <div class="col-xs-12 text-xs-right">
                        <button *ngIf="!responseMessage" type="button" class="btn btn-secondary" (click)="hideModal()">
                            {{ 'Cancel' | translate }}
                        </button>
                        <button *ngIf="responseMessage" type="button" class="btn btn-secondary" (click)="hideModal()">
                            {{ 'Close' | translate }}
                        </button>
                        <button *ngIf="!responseMessage" type="button" class="btn btn-primary" (click)="params['action'] === 'archive' ?
                                    archiveQuestionnaires(params['id']) :
                                    deleteQuestionnaires(params['id'])">
                            {{ 'OK' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Reminder Modal -->
    <div *ngIf="params['action'] === 'reminder'" class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ params['title'] | translate }}</h4>
                <button type="button" class="btn btn-link fal fa-times close" (click)="hideModal()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <ng-template [ngIf]="!formLoading">
                    <form [formGroup]="form" novalidate class="mat-form">
                        <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                            <div class="col-sm-10">
                                <div class="alert alert-danger">
                                    <div *ngFor="let error of errorMessage">
                                        <i class="fas fa-clock" aria-hidden="true"></i> {{ error | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-4">
                                <div class="se-type se-type--email active">
                                    <span class="se-type--label">{{ 'By email' | translate }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row mr-t--md">
                            <div class="form-group col-xs-12">
                                <button (click)="isCollapsed = !isCollapsed"
                                    class="btn btn-gray btn-icon collapse-button"
                                    type="button">
                                    <span *ngIf="isCollapsed">
                                        <i class="fas fa-angle-right"></i>{{ 'More Options' | translate }}
                                    </span>
                                    <span *ngIf="!isCollapsed">
                                        <i class="fas fa-angle-up"></i>{{ 'More Options' | translate }}
                                    </span>
                                </button>
                            </div>
                            <div *ngIf="!isCollapsed">
                                <div class="form-group col-xs-8">
                                    <mat-form-field class="ps-content">
                                        <input type="email" [placeholder]="'Sending Reminder To' | translate"
                                                            [value]="form.controls.email.value"
                                                            matInput
                                                            disabled />
                                        <small class="form-text" [hidden]="form.controls.email.valid || (form.controls.email.pristine && !formSubmitted)">
                                            {{ 'Email is invalid.' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-xs-6">
                                    <div class="form-customized mat-form-field-wrapper {{ validateCssDueDate }}">
                                        <label>{{ 'Due Date' | translate }}</label>
                                        <span class="required-marker"> *</span>
                                        <my-date-picker formControlName="due_date" class="kl-datepicker" required placeholder="dd.mm.yyyy" [options]="dpkDueDateOptions"
                                            (inputFocusBlur)="onDueDateFocusBlur($event)" (inputFieldChanged)="onDueDateInputChanged($event)"
                                            required></my-date-picker>
                                        <div class="mat-input-underline mat-form-field-underline">
                                            <span class="mat-input-ripple mat-form-field-ripple"></span>
                                        </div>
                                        <small class="form-text" [hidden]="form.controls.due_date.valid
                                            || (form.controls.due_date.pristine && !formSubmitted)
                                            || form.controls.due_date.disabled">
                                                {{ 'Date format is dd.mm.yyyy' | translate }}
                                        </small>
                                    </div>
                                </div>
                                <div class="form-group col-xs-10">
                                    <mat-form-field class="ps-content">
                                        <mat-select [placeholder]="'Email Template' | translate" required="required"
                                                    formControlName="template_translation_id"
                                                    [(ngModel)]="selectedTemplateReminderId"
                                                    (selectionChange)="onSelectReminderTemplate()">
                                            <mat-option *ngFor="let emailReminderTemplate of emailReminderTemplates" [value]="emailReminderTemplate['id']">
                                                    {{ emailReminderTemplate['title'] }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="row" *ngIf="form.controls.content.dirty">
                            <div class="col-md-12">
                                <a class="btn btn-link pull-right" (click)="onRevertTemplateReminder()">
                                    ({{ 'Discard changes' | translate }})
                                </a>
                            </div>
                        </div>

                        <div class="row reminder">
                            <label class="form-group col-xs-12">{{ 'Message' | translate }}</label>
                            <div class="col-sm-12">
                                <app-tinymce formControlName="content"></app-tinymce>
                                <small class="form-text text-danger" [hidden]="form.controls.content.valid
                                                   || form.controls.content.disabled
                                                   || (form.controls.content.pristine && !formSubmitted)">
                                    {{ 'Questionnaire link is missing: Please revert to the original template or insert a link for the questionnaire (via the editor), with the Title value: questionnaire-link, Url value: #.' | translate}}
                                </small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 text-xs-left">
                                <button type="submit" class="btn btn-primary btn--send-reminder" (click)="sendReminder(form.value, form.valid)">
                                    {{ 'Send' | translate }}
                                </button>
                                <button type="button" class="btn btn-secondary badge-pill" (click)="hideModal()">
                                    {{ 'Cancel' | translate }}
                                </button>
                            </div>
                        </div>
                    </form>
                </ng-template>
            </div>
        </div>
    </div>
    <!-- Open and Send Questionnaire Modal-->
    <div *ngIf="formAction === 'send' || formAction === 'open'" class="modal-dialog questionnaire">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span>
                        {{ titleText | translate }}
                    </span>
                </h4>
            </div>
            <div class="modal-body patient-questionnaire-form">
                <button type="button" class="btn btn-link close" (click)="hideModal()" aria-label="Close"></button>
                <ng-template [ngIf]="!formLoading">
                    <form [formGroup]="form" novalidate (ngSubmit)="submit(form.value, form.valid)" class="mat-form">
                        <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                            <div class="col-sm-10">
                                <div class="alert alert-danger">
                                    <div *ngFor="let error of errorMessage">
                                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                        {{ error | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="responseMessage != null && responseMessage != ''" class="row form-group"
                             role="alert">
                            <div class="col-sm-10">
                                <div class="alert-success alert">
                                    <i class="fas fa-check" aria-hidden="true"></i> {{ responseMessage | translate}}
                                </div>
                            </div>
                        </div>
                        <input type="text" name="patient_id" formControlName="patient_id" class="hidden-xs-up">
                        <div hidden class="row questionnaire--selection-questionnaire">
                            <div class="form-group col-xs-12">
                                <label>{{ 'Select Questionnaire' | translate }} *</label>
                                <div *ngFor="let questionnaire of questionnaires">
                                    <input type="radio" id="questionnaire-{{ questionnaire['type'] }}"
                                           [value]="questionnaire['type']" formControlName="questionnaire_type_id"
                                           (change)="onQuestionTypeChange(questionnaire.type)"/>
                                    <label for="questionnaire-{{ questionnaire['type'] }}">
                                        {{ questionnaire['name'] | translate }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div hidden class="row">
                            <div class="form-group col-xs-12">
                                <label>{{ 'Way to Complete' | translate }} *</label>
                                <div>
                                    <input type="radio" formControlName="answer_method" name="answer_method"
                                           id="answerMethodLocalInput" value="local"
                                           (change)="onAnswerMethodChange('local')"
                                    />
                                    <label for="answerMethodLocalInput">
                                        {{ 'Self Evaluation On Local Device' | translate }}
                                    </label>
                                </div>
                                <div [ngClass]="(questionType == 'di') ? 'email-answer-disable':''">
                                    <input type="radio" formControlName="answer_method" name="answer_method"
                                           id="answerMethodEmailInput" value="email"
                                           (change)="onAnswerMethodChange('email')"
                                    />
                                    <label for="answerMethodEmailInput">
                                        {{ 'Send By Email' | translate }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div [ngClass]="(!isEmailQuestionnaire) ? 'email-answer-disable':''">
                            <div class="row">
                                <div class="form-group col-xs-6">
                                    <mat-form-field class="ps-content">
                                        <input type="email" matInput [placeholder]="'Send To' | translate" required="required" formControlName="email" />
                                        <input type="text" class="form-control hidden-xs-up" formControlName="token"/>
                                        <small class="form-text" [hidden]="form.controls.email.valid
                                        || form.controls.email.disabled
                                        || (form.controls.email.pristine && !formSubmitted)">
                                            {{ 'Require this format: name@company.com' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-6">
                                    <div class="form-customized mat-form-field-wrapper {{ validateCssDueDate }}">
                                        <label>{{ 'Due Date' | translate }} *</label>
                                        <my-date-picker formControlName="due_date" class="kl-datepicker" required placeholder="dd.mm.yyyy" [options]="dpkDueDateOptions"
                                            (inputFocusBlur)="onDueDateFocusBlur($event)" (inputFieldChanged)="onDueDateInputChanged($event)"
                                            required></my-date-picker>
                                        <div class="mat-input-underline mat-form-field-underline">
                                            <span class="mat-input-ripple mat-form-field-ripple"></span>
                                        </div>
                                        <small class="form-text" [hidden]="form.controls.due_date.valid
                                        || (form.controls.due_date.pristine && !formSubmitted)
                                        || form.controls.due_date.disabled">
                                            {{ 'Date format is dd.mm.yyyy' | translate }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-xs-6">
                                <mat-form-field class="ps-content">
                                    <mat-select [placeholder]="'Email Template' | translate" formControlName="template_translation_id" [(ngModel)]="selectedTemplateTranslationId" (selectionChange)="onSelectEmailTemplate()">
                                        <mat-option *ngFor="let questionnaireEmailTemplate of questionnaireEmailTemplates" [value]="questionnaireEmailTemplate['id']">
                                            {{ questionnaireEmailTemplate['title'] }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-xs-6 discard">
                                <a class="btn btn-link btn-revert" *ngIf="form.controls.content.dirty"
                                   (click)="onRevertTemplate($event.target.value)">
                                    <small>({{ 'Discard changes' | translate }})</small>
                                </a>
                            </div>
                        </div>
                        <div class="row questionnaire--email-content">
                            <div class="form-group col-xs-12">
                                <app-tinymce #tinymce formControlName="content" id="mail_content"></app-tinymce>
                                <small class="form-text text-danger" [hidden]="form.controls.content.valid
                                                   || form.controls.content.disabled
                                                   || (form.controls.content.pristine && !formSubmitted)">
                                    {{ 'Questionnaire link is missing: Please revert to the original template or insert a link for the questionnaire (via the editor), with the Title value: questionnaire-link, Url value: #.' | translate}}
                                </small>
                            </div>
                        </div>
                        <div class="row questionnaire--button-group">
                            <div class="col-xs-12 text-xs-right">
                                <button type="button" class="btn btn-secondary" (click)="hideModal()">
                                    {{ 'Cancel' | translate }}
                                </button>
                                <button type="submit" class="btn btn-primary">
                                    {{ btnSubmitText | translate }}
                                </button>
                            </div>
                        </div>
                    </form>
                </ng-template>
            </div>
        </div>
    </div>
</div>

<dialog-component #dialog></dialog-component>